<template>
  <a-button @click="showSubVideoClipList" class="menu-button" v-on="$listeners" v-bind="$props">
    <slot />
  </a-button>
</template>
<script>
import { Button } from "ant-design-vue";

export default {
  props: Button.props,
  methods: {
    showSubVideoClipList(){}
  }
}
</script>
<style scoped>
.menu-button {
  width: 100%;
  height: 40px;
  background: #007eff;
  border: 0;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 18px 0 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.menu-button:hover,
.menu-button:focus {
  background-color: #409eff;
}

.menu-button:active {
  background-color: #006ddd;
}
</style>
